import stateStore from "@/store";

/** Старшая медсестра — права nurse, без привязки к одному посту */
export const HEAD_NURSE_ROLE = "head_nurse";
export const NURSE_ROLE = "nurse";

export function expandUserRoles(roles: string[] = []): string[] {
	const set = new Set((roles || []).filter(Boolean).map(String));
	if (set.has(HEAD_NURSE_ROLE)) set.add(NURSE_ROLE);
	return [...set];
}

export function userHasAnyRole(
	userRoles: string[] = [],
	required: string | string[],
): boolean {
	const expanded = expandUserRoles(userRoles);
	const list = Array.isArray(required) ? required : [required];
	return list.some((r) => expanded.includes(r));
}

/** Рядовая медсестра: UI/фильтры режут по посту */
export function isPostRestrictedNurse(roles?: string[]): boolean {
	const list = roles ?? stateStore.state?.user?.roles ?? [];
	return (
		list.includes(NURSE_ROLE) && !list.includes(HEAD_NURSE_ROLE)
	);
}
